export default "__VITE_ASSET__DzzpdtQO__"